'use strict';

import { selectAccordionElements } from "./elements/accordionElements";

export default class Accordion
{
    constructor() {
        this.elements = selectAccordionElements();
        this.questionDown = this.onQuestionDown.bind(this);
        this.addEventListeners();
    }

    addEventListeners() {
        this.elements.questions.forEach(question => {
            question.addEventListener('mousedown', this.questionDown);
        });
    }

    onQuestionDown(event) {
        const question = event.currentTarget;
        const answer = this.elements.answer(question);
        const content = this.elements.content(question);
        const boundingClientRect = content.getBoundingClientRect();
        const height = boundingClientRect.height;
        if (answer.style.height === '' ||
            answer.style.height === '0' ||
            answer.style.height === '0px'
        ) {
            answer.style.height = `${height}px`;
        } else {
            answer.style.height = '0';
        }
    }
}
